module.exports = __webpack_public_path__ + "img/pdfbg.ebe919c6.png";